const SvgDisk = props => (
  <svg height="1em" viewBox="0 0 24 23" width="1em" {...props}>
    <path
      d="M16.312 16.31l1.057-2.618 2.618 1.057-1.057 2.618-2.618-1.057zm2.733-5.802l2.645-6.545 2.618 1.058-2.645 6.545-2.618-1.058zm-7.25 3.61a2.823 2.823 0 0 1-2.824-2.824 2.814 2.814 0 0 1 2.823-2.823 2.824 2.824 0 1 1 0 5.647zm0-14.118C5.556 0 .5 5.057.5 11.294c0 6.238 5.057 11.294 11.294 11.294a11.294 11.294 0 0 0 11.294-11.294C23.088 5.057 18.032 0 11.794 0z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default SvgDisk
